<template>
  <div>
    <v-img
        :src="require('@/assets/images/loginPageBackground.jpg')"
        height="100vh"
        class="white--text"
        gradient="to bottom, rgba(11, 28, 61, .9), rgba(0,0,0,.4)"
    >
      <div class="d-flex justify-center align-center h-100">
        <v-card style="max-width: 420px" elevation="3">
          <v-card-text>
            <div class="d-flex justify-center my-8">
              <v-img
                  alt="Decentral Store Logo"
                  class="shrink mr-2"
                  contain
                  src="@/assets/images/decentralStoreLogo.png"
                  transition="scale-transition"
                  width="72"
              />
            </div>

            <div class="text-center my-8">
              <h2>Decentral Store Login</h2>
            </div>

            <div class="my-4">
              <v-btn
                  block
                  color="indigo darken-3"
                  @click="login"
                  dark
                  :loading="loginLoading"
              >Login with Metamask Wallet</v-btn>
            </div>

            <div class="my-4">
              <v-btn
                  block
                  color="indigo lighten-2"
                  dark
                  :href="metamaskDownloadURL"
                  target="_blank"
              >Download Metamask Wallet</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </v-img>
  </div>
</template>

<script>
import metamask from "@/lib/metamask/index";
import commonConfig from "@/config/commonConfig"
import Vue from 'vue'

export default {
  name: "AppLogin",
  methods: {
    async login() {
      try {
        this.loginLoading = true
        await metamask.wallet.connectWallet()
        await metamask.auth.login()
        if (window.history.length > 0) {
          await this.$router.back()
        }else {
          await this.$router.push({name: 'storeSearch'})
        }
      }catch (e) {
        console.error(e)
        Vue.notify({
          type: "error",
          text: e.message
        })
      }finally {
        this.loginLoading = false
      }
    },
  },
  data() {
    return {
      metamaskDownloadURL: commonConfig.metamaskDownloadURL,
      loginLoading: false
    }
  }
}
</script>

<style scoped>

</style>